if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedCollection', (sectionId, pageParam, container, isRtl = false) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        isRtl: Boolean(isRtl),
        currentTab: 1,
        loading: true,
        loaded: [],
        select(index) {
          this.currentTab = index;
          const tab = document.getElementById(`fc-tab-${this.sectionId}-${index}`);
          const url = tab?.dataset?.collectionUrl ?? '';
          const host = container.closest('.x-container-featured-collection');
          if (host && window.Alpine && typeof window.Alpine.$data === 'function') {
            const scope = window.Alpine.$data(host);
            if (scope && typeof scope.setViewAllLink === 'function') {
              scope.setViewAllLink(url);
            }
          }
          this.$nextTick(() => tab?.focus());
        },
        tabKeydown(event, index, tabCount) {
          const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          const rtl = this.isRtl;
          let next = index;
          const forward = (!rtl && event.key === 'ArrowRight') || (rtl && event.key === 'ArrowLeft');
          const backward = (!rtl && event.key === 'ArrowLeft') || (rtl && event.key === 'ArrowRight');
          if (forward) {
            next = index % tabCount + 1;
          } else if (backward) {
            next = index === 1 ? tabCount : index - 1;
          } else if (event.key === 'Home') {
            next = 1;
          } else if (event.key === 'End') {
            next = tabCount;
          }
          if (next !== index) {
            this.select(next);
            const nextTab = document.getElementById(`fc-tab-${this.sectionId}-${next}`);
            if (nextTab) {
              this.scrollIntoView(nextTab);
            }
          }
        },
        loadData(index) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage)) {
            this.loading = true;
            
            let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;
              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId)) {
                container.appendChild(newContent);
                this.loaded.push(selectedPage);
              }
              this.loading = false;
            })
          }
        },
        scrollIntoView(element) {
          const scrollableContainer = element.closest('.overflow-x-auto');
          if (!scrollableContainer) return;
          const elementPosition = element.offsetLeft;
          scrollableContainer.scroll({
            left: elementPosition,
            behavior: 'smooth'
          });
        }
      }));
    });
  });
}